import {Component, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {ITileViewSelection, IVirtualGridTile} from '@shared/interfaces/virtual-grid-tile';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Router} from '@angular/router';
import {SnackBarService} from '@core/services/snack-bar.service';
import {UrlUtility} from '@shared/utility/url-utility';

@Component({
    standalone: false,
    selector: 'app-chapter-tile-view',
  templateUrl: './chapter-tile-view.component.html',
  styleUrls: ['./chapter-tile-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChapterTileViewComponent implements OnInit, IVirtualGridTile {
  data: any;
  invalidateSubject: InvalidateSubject;
  itemSelectionChanged: EventEmitter<ITileViewSelection>;
  valueChanged: EventEmitter<any>;
  tag: string;
  tagTooltip: string;

  constructor(private router: Router,
              private snackBarService: SnackBarService) { }

  ngOnInit(): void {
    this.convertTagAndTooltip();
  }

  navigateToUrl() {
    if (this.data.cells['NavigationUrl']) {
      if (this.data.cells['Tag'].value === 'HyperLink'){
        window.open(UrlUtility.getUrlWithProtocol(this.data.cells['NavigationUrl'].value), '', "noopener,noreferrer");
        return;
      }
      this.router.navigateByUrl(this.data.cells['NavigationUrl'].value);
    } else {
      this.snackBarService.showError("Navigation url not found.");
    }
  }

  convertTagAndTooltip() {
    const originalTag = this.data?.cells['Tag']?.value;
    if (originalTag === 'CHAPTER') {
      this.tag = 'Text';
      this.tagTooltip = 'This document is displayed as text with a table of contents to navigate the different chapters.';
    } else if (originalTag === 'HyperLink') {
      this.tag = 'External';
      this.tagTooltip = 'This is an external document. Clicking this document will open the external website in a new tab.';
    } else if (originalTag === 'PDF') {
      this.tag = this.data?.cells['Tag']?.value;
      this.tagTooltip = 'This document is displayed as an embedded PDF.';
    } else {
      this.tag = this.data?.cells['Tag']?.value;
      this.tagTooltip = '';
    }
  }
}
